import {
  getAllStudentRecognitionEventByLicenseAsync,
  getStudentRecognitionEventByIdAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useGetStudentRecognitionEventByIdAsync = () =>
  useMutation(getStudentRecognitionEventByIdAsync);

export const useGetAllStudentRecognitionEventByLicenseAsync = () =>
  useMutation(getAllStudentRecognitionEventByLicenseAsync);
